/** Projects delivered / happy clients, shown as "200+" across the site. */
export const PROJECTS_DELIVERED = 200;
